import { INTEGRATIONS_FILTERS_DICTIONARY } from "./constants";
import { IntegrationView } from "./types";

export const filterIntegrations = (
  integrations: (IntegrationView | undefined)[],
  searchQuery: string,
  categoryValues?: string[]
): IntegrationView[] => {
  const filterIntegrationsBySearchQuery = (
    integration: IntegrationView | undefined
  ): integration is IntegrationView => {
    if (!integration) return false;

    if (searchQuery && !integration.name.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }

    if (!categoryValues?.length) return true;

    return categoryValues.some(
      (value) => INTEGRATIONS_FILTERS_DICTIONARY[integration.type] === value
    );
  };
  const filteredIntegrations = integrations.filter(filterIntegrationsBySearchQuery);

  return filteredIntegrations;
};
